"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var GoogleMap_1 = require("@/api/vendor/GoogleMap");
var mapLocation = function (props) {
    var dataAttr = {
        dataname: props.name,
        datalat: props.lat,
        datalng: props.lng,
        datamaptype: props.mapType === GoogleMap_1.GoogleMapType.ROADMAP ? 'roadmap' : 'satellite',
    };
    return (React.createElement("div", __assign({ id: props.id, style: { height: '100%' }, className: "google-map-location" }, dataAttr)));
};
exports.default = mapLocation;
